import { Table, TableColumnsType } from "antd";
import _ from "lodash";
import moment from "moment";
import { FC, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import exportTable from "../../../lib/exportTable";
import { IHomeworkSummary } from "../../../models/statistics.model";
import DownloadButton from "../../DownloadButton";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import useUtil from "../../../hooks/useUtil";
import { ISemesterMonth } from "../../../models/semesters.model";
import Pagination from "../../Pagination";

interface IProps {
  rawData: IHomeworkSummary[]|undefined;
  rawData2: ISemesterMonth[]|undefined;
}

const Summary: FC<IProps> = ({
  rawData,
  rawData2
}) => {
  const { t } = useTranslation();
  const { getCommonCodeLabel } = useUtil();
  const [data, setData] = useState<IHomeworkSummary[]>([]);
  const [searchMonth, setSearchMonth] = useState<String[]>([]);
  const { campusData } = useSelector((state: RootState) => state.campusData);
  const [pageNo, setPageNo] = useState(1);
  const perPage = 50;

  useEffect(() => {
    if (rawData) {
      const newData: any = _.cloneDeep(rawData);

      newData.forEach((item: any, idx: number) => {
        item.rowIdx = idx;
        const campus = campusData.find(campus => campus.campusCode === item.campusCode);
        if (campus) {          
          item.campusKorName = campus.campusKorName;
        } else {
          if(item.campusCode == 'ALL') {
            item.campusKorName = t('common.text.all');
          } else {
            item.campusKorName = '';
          }
        }

        item.eduStepCode = getCommonCodeLabel('PR0006', item.eduStepCode);
        item.avgFirst = (item.avgFirst === null) ? '-' : item.avgFirst;
        item.avgSecond = (item.avgSecond === null) ? '-' : item.avgSecond;
        item.avgThird = (item.avgThird === null) ? '-' : item.avgThird;
        item.totAvgScore = (item.totAvgScore === null) ? '-' : item.totAvgScore;
        item.completeRateFirst = (item.completeRateFirst === null) ? '-' : item.completeRateFirst + '%';
        item.completeRateSecond = (item.completeRateSecond === null) ? '-' : item.completeRateSecond + '%';
        item.completeRateThird = (item.completeRateThird === null) ? '-' : item.completeRateThird + '%';
        item.totAvgRate = (item.totAvgRate === null) ? '-' : item.totAvgRate + '%';
      });

      setData(newData);
    }
  }, [rawData]);

  const onExportTable = () => {
    const currentDate = moment(new Date());
    exportTable(columns, data, `${t('statistics.homework.title1')}(${t('statistics.attendance.Tab1')})_(${currentDate.format('YYYYMMDD')})`, `${t('statistics.attendance.Tab1')}`, [12, 12, 10, 10, 12]);
  }

  useEffect(() => {
    const pondSearchMonth : Array<string> = [];
    if(rawData2 !== undefined && rawData2.length === 3){
      pondSearchMonth.push(rawData2[0].monthName + t('statistics.placementTest.1'));
      pondSearchMonth.push(rawData2[1].monthName + t('statistics.placementTest.1'));
      pondSearchMonth.push(rawData2[2].monthName + t('statistics.placementTest.1'));
    } else {
      pondSearchMonth.push('-');
      pondSearchMonth.push('-');
      pondSearchMonth.push('-');
    }
    setSearchMonth(pondSearchMonth);
  }, [rawData2]);

  const columns: TableColumnsType<IHomeworkSummary> = [
    {
      title: t('common.menu.campus'),
      dataIndex: 'campusKorName',
      key: 'campusKorName',
      align: 'center',
    },
    {
      title: t('common.label.1'),
      dataIndex: 'eduStepCode',
      align: 'center',
    },
    {
      title: t('statistics.dttt.column1'),
      dataIndex: 'courseName',
      key: 'courseName',
      align: 'center',
    },
    {
      title: t('statistics.dttt.column2'),
      children: [
        {
          title: searchMonth[0],
          dataIndex: 'avgFirst',
          key: 'avgFirst',
          align: 'center',
        },
        {
          title: searchMonth[1],
          dataIndex: 'avgSecond',
          key: 'avgSecond',
          align: 'center',
        },
        {
          title: searchMonth[2],
          dataIndex: 'avgThird',
          key: 'avgThird',
          align: 'center',
        },
        {
          title: t('statistics.studentEnrollMonth.column9'),
          dataIndex: 'totAvgScore',
          align: 'center',
        }
      ]
    },
    {
      title: t('statistics.homework.column3') + '(%)',
      children: [
        {
          title: searchMonth[0],
          dataIndex: 'completeRateFirst',
          key: 'completeRateFirst',
          align: 'center',
        },
        {
          title: searchMonth[1],
          dataIndex: 'completeRateSecond',
          key: 'completeRateSecond',
          align: 'center',
        },    
        {
          title: searchMonth[2],
          dataIndex: 'completeRateThird',
          key: 'completeRateThird',
          align: 'center',
        },    
        {
          title: t('statistics.studentEnrollMonth.column9'),
          dataIndex: 'totAvgRate',
          align: 'center',
        }
      ]
    }
  ];

  return (
    <>
      <div className="comm-table__area line-type">
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            current: pageNo,
            pageSize: perPage,
          }}
          rowClassName={(record: IHomeworkSummary) => record.campusCode === 'ALL' ? 'tfoot' : ''}
          rowKey={'rowIdx'}
        />
      </div>
      <div className="comm-bx__between">
        <DownloadButton onClick={onExportTable} />
        <div className="common-paging center">
          <Pagination
            count={rawData?.length || 0}
            page={pageNo}
            setPage={setPageNo}
            perPage={perPage}
          />
        </div>
      </div>
    </>
  );
}

export default Summary;
